module.exports = __webpack_public_path__ + "static/media/hangman3.d93d2112.png";